export interface CreditCardInterface {
    id?: string;
    number?: string;
    cvv?: string;
    holder?: string;
    dateExpiration?: string;
}

export class CreditCard implements CreditCardInterface {
    public id?: string;
    public number?: string;
    public cvv?: string;
    public holder?: string;
    public dateExpiration?: string;
}
